<template>
    <div :class="{'palmira': ($root.template === 'video_template' || $root.template === 'slider_template') && $route.name !== 'home'}">
        <loading v-if="loading"></loading>
        <div class="px-2" id="scroll-services"  v-if="($root.template === 'video_template' || $root.template === 'slider_template') && $route.name === 'home'">
            <vue-horizontal scroll @scroll="onScrollHorizontal" :button="!$root.isMobile()" class="horizontal" ref="horizontal" snap="none" v-if="sections">
                <div class="section" v-for="section in sections" v-show="!section.is_hidden" v-if="!section.is_hidden">
                    <div @click.prevent="clickHorizontalSection(section)"
                         class="bg-gradient-to-t from-[#00000075] p-[7px] relative bg-cover to-transparent flex items-end justify-center  rounded-[20px] text-[#fff] text-[14px] text-center pb-[15px] cursor-pointer"
                         :class="isDesktopVersion() ? 'h-[300px] w-[230px]' : 'h-[210px] w-[140px]'"
                         v-bind:style="{backgroundImage: getHomePageImage(section.home_page_image)}">
                        <div class="z-10">
                            <div class="temporary-unavailable"
                                 v-if="!section.in_schedule && displayScheduleText(section)">
                                <div v-bind:style="unavailableSectionBackground + 'color: ' + $root.hotel.ext_data.unavailable_section_font_color"
                                     class="temporary-unavailable_text bg-black/50 flex gap-1 justify-center">
                                    <span v-html="displayScheduleText(section)"></span>
                                </div>
                            </div>
                            <p :style="getColorText" v-if="!$root.hotel.tile_hide_name" class="section-title">
                               {{  customTextFormater($root.getLangText(section.title)) }}
                            </p>
                        </div>
                        <div class="absolute w-full h-full bottom-0 rounded-[20px] z-0" style="padding: inherit" :style="{backgroundImage: createBackgroundString}"></div>
                    </div>
                </div>
            </vue-horizontal>
        </div>
        <div class="flex flex-wrap" :class="{'pb-[60px]': ($route.path !== '/' && $route.path !== '/home') && ($root.template === 'video_template' || $root.template === 'slider_template')}" v-else>
            <div class="item" v-for="section in sections" v-show="!section.is_hidden"
                 :class="[section.is_image_full ? 'full' : '', $root.hotelCode === 'marriottpolyana' || $root.hotelCode === 'marriottimperialplaza' || $root.hotelCode === 'marriottroomservice' || $root.hotelCode === 'marriott-krasnodar' || $root.hotelCode === 'marins-nsk' || $root.hotelCode === 'marins-astrakhan' || $root.hotelCode === 'marins-nn' || $root.hotelCode === 'marins-ek' || $root.hotelCode === 'marins-rostov' || $root.hotelCode === 'marins-moscow' || $root.hotelCode === 'tropikana' ? 'lg:pb-10 md:pb-8 pb-6' : '', $root.hotelCode === 'yaltaintourist' ? 'lg:pb-10 md:pb-8 pb-6' : '']"
                 :key="section.id">
                <div class="child"
                     :class="[$root.hotelCode ? $root.hotelCode : '', $root.hotel.tile_show_border ? 'with_border' : '']"
                     @click="clickSection(section)">
                    <div class="image_position image_root relative"
                         :style="($root.hotel.tile_color_border && $root.hotel.tile_show_border) ? 'border: 1px solid ' + $root.hotel.tile_color_border : ''">

                        <div class="temporary-unavailable z-10" v-if="!section.in_schedule && displayScheduleText(section)">
                            <div v-bind:style="unavailableSectionBackground + 'color: ' + $root.hotel.ext_data.unavailable_section_font_color"
                                 class="temporary-unavailable_text bg-black/50 flex gap-1 justify-center">
                                <span v-html="displayScheduleText(section)"></span>
                            </div>
                        </div>

                        <div class="image z-10" v-bind:style="{backgroundImage: getHomePageImage(section.home_page_image)}">
                            <a class="link">
                                <div class="flex items-center z-10">
                                    <div class="mr-2 icon-card" v-if="section.icon_path">
                                        <img class="h-4 w-4 md:h-8 md:w-8 object-contain"
                                             :src="$root.getImage(section.icon_path)" alt="">
                                    </div>
                                    <div :style="getColorText" class="image_text hypen break-words"
                                         v-if="!$root.hotel.tile_hide_name">
                                        {{ $root.getLangText(section.title) }}
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div  v-if="$root.hotelCode == 'marriottpolyana' || $root.hotelCode === 'marriottimperialplaza' || $root.hotelCode === 'marriottroomservice' || $root.hotelCode === 'marriott-krasnodar' || $root.hotelCode === 'marins-nsk' || $root.hotelCode === 'marins-astrakhan' || $root.hotelCode === 'marins-nn' || $root.hotelCode === 'yaltaintourist' || $root.hotelCode === 'marins-ek' || $root.hotelCode === 'marins-rostov' || $root.hotelCode === 'marins-moscow' || $root.hotelCode === 'tropikana'"
                             class="pt-1 pb-2 z-10">
                            <div :style="getColorText"
                                 class="image_text hypen break-words sm:text-lg text-black leading-none">
                                {{ $root.getLangText(section.title) }}
                            </div>
                        </div>

                        <div class="absolute w-full h-full bottom-0 rounded-[10px] z-0" style="padding: inherit" :style="{backgroundImage: createBackgroundString}"></div>
                    </div>

                    <div class="py-1 font-light item-title md:items-center">
                        <div class="w-5 flex flex-shrink-0" v-if="section.icon_path">
                            <img class="h-5" :src="$root.getImage(section.icon_path)" alt="">
                        </div>
                        <div class="leading-none mt-1" :style="getColorText">
                            {{ hyphenText($root.getLangText(section.title)) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <article-extra-popup></article-extra-popup>
    </div>
</template>

<script>
import Loading from './ArticleLoading.vue';
import ArticleExtraPopup from './../../pages/Product/ArticleExtraPopup';
import {SectionRouter} from '@/components/mixins/SectionRouter';
import {eventBus} from '../../main';
import carousel from 'vue-owl-carousel';
import VueHorizontal from 'vue-horizontal';

export default {
    components: {Loading, ArticleExtraPopup, carousel, VueHorizontal},

    props: ['parentSection'],
    mixins: [SectionRouter],

    data() {
        return {
            unavailableSectionOpacity: 0.8,
            prev_item: false,
            sections: null,
            loading: true,
            disabled_link: false,
            left: 0,
            startX: 0,
            startY: 0,
            scroll: false,
        }
    },

    watch: {
        '$route.path': function (val, oldVal) {
            this.fetchSections(this.$route.params.id === undefined ? null : this.$route.params.id);
        }
    },

    created() {
        this.fetchSections(this.$route.params.id === undefined ? null : this.$route.params.id);

        eventBus.$on('is-draging', data => {
            let $this = this;
            // console.log('start',this.disabled_link);
            setTimeout(function () {
                $this.disabled_link = true;
                $this.click = false;
            }, 100);
        });

        eventBus.$on('draging-over', data => {
            // console.log('over', this.disabled_link);
            let $this = this;
            setTimeout(function () {
                $this.disabled_link = false;
                $this.click = true;
            }, 100);
        });
    },

    computed: {
        getColorText() {
            var color = this.$root.hotel.set_default_color
                ? this.$root.hotel.tile_color_text
                : this.$root.hotel.color;

            return 'color: ' + color;
        },

        unavailableSectionBackground() {
            let hexColor = this.$root.hotel.ext_data.unavailable_section_background_color ? this.$root.hotel.ext_data.unavailable_section_background_color : '#ffffff';
            let rgbColor = this.hexToRgb(hexColor);
            return 'background: rgba(' + rgbColor.r + ',' + rgbColor.g + ',' + rgbColor.b + ',' + this.unavailableSectionOpacity + ');';
        },

        createBackgroundString() {
            let style = null;
            let section_gradient = this.$root.hotel.ext_data.section_gradient;
            let section_gradient_opacity = this.$root.hotel.ext_data.section_gradient_opacity;
            // console.log(section_gradient, section_gradient_opacity);
            if (section_gradient) {
                style = `linear-gradient(to bottom, rgba(255,0,0,0) ` + (100 - section_gradient_opacity) + `% , rgba(` + section_gradient.r + `,` + section_gradient.g + `,` + section_gradient.b + `,` + section_gradient.a + `))`;
            }
            return style;
            // return `linear-gradient(to bottom, rgba(255,0,0,0) 50%, rgba(255,0,0,1))`;
        }

    },

    methods: {
        async fetchSections(parent_id = null) {
            this.loading = true;

            if (this.$root.hotel === undefined || this.$root.hotel.length == 0) {
                await this.$root.getHotel();
            }

            if (parent_id)
                await this.fetchParentSeciton(parent_id);

            await this.$http.get(process.env.VUE_APP_API_URL + 'public/sections?hotel_uuid=' + this.$root.hotel.uuid + '&parent_id=' + parent_id)
                .then(response => {
                    this.sections = response.data.data;
                    this.loading = false;
                });
        },

        async fetchParentSeciton(parent_id) {
            await this.$http.get(process.env.VUE_APP_API_URL + 'public/sections/' + parent_id)
                .then(response => {
                    var parentSection = response.data.data;

                    if (parentSection && parentSection.hide_back_button) {
                        if (document.querySelector('#homeBackButton')) {
                            document.querySelector('#homeBackButton').style.display = 'none';
                        }

                        if (document.querySelector('#bottomHomeBackButton')) {
                            document.querySelector('#bottomHomeBackButton').style.display = 'none';
                        }

                        if (document.querySelector('#bottomServices')) {
                            document.querySelector('#bottomServices').style.display = 'none';
                        }
                    }

                    this.$emit('update:parentSection', parentSection);

                    eventBus.$emit('modal-announcement', {
                        parent_section_id: parentSection.id,
                    });
                });
        },

        onScrollHorizontal(e) {
            this.scroll = true;

            setTimeout(() => {
                this.scroll = false;
            }, 100);
        },

        clickHorizontalSection(item) {
            if (!this.scroll)
                this.clickSection(item);
        },

        clickSection(item) {
            if (this.disabled_link === false || this.$root.isMobile()) {
                this.$root.yandexGoal('goal - category - ' + item.id);

                // check section is 18+
                let ask_user_is_adult = (localStorage.getItem('is_adult') === undefined || localStorage.getItem('is_adult') === null)
                    && ((item.for_adult !== null && item.for_adult) || (this.parentSection && this.parentSection.for_adult));

                if (ask_user_is_adult) {
                    this.$modal.show('modal-extra', {item: item, section_id: item.id});
                    return false;
                }

                this.routeSectionLink(item);
            }
        },

        hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },

        getHomePageImage(url) {
            return 'url(' + process.env.VUE_APP_IMG_URL + url + ')';
        },

        hyphenText(text) {
            var e = "[абвгдеёжзийклмнопрстуфхцчшщъыьэюя]";
            var t = "[аеёиоуыэюя]";
            var n = "[бвгджзклмнпрстфхцчшщ]";
            var r = "[йъь]";
            var i = "­";
            var s = new RegExp("(" + r + ")(" + e + e + ")", "ig");
            var o = new RegExp("(" + t + ")(" + t + e + ")", "ig");
            var u = new RegExp("(" + t + n + ")(" + n + t + ")", "ig");
            var a = new RegExp("(" + n + t + ")(" + n + t + ")", "ig");
            var f = new RegExp("(" + t + n + ")(" + n + n + t + ")", "ig");
            var l = new RegExp("(" + t + n + n + ")(" + n + n + t + ")", "ig");

            var e1 = text;
            e1 = e1.replace(s, "$1" + i + "$2");
            e1 = e1.replace(o, "$1" + i + "$2");
            e1 = e1.replace(u, "$1" + i + "$2");
            e1 = e1.replace(a, "$1" + i + "$2");
            e1 = e1.replace(f, "$1" + i + "$2");
            e1 = e1.replace(l, "$1" + i + "$2");
            return e1;
        },

        formatTime(time) {
            var splitTime = time.split(':');
            return splitTime.length > 2 ? splitTime[0] + ':' + splitTime[1] : time;
        },

        customTextFormater(text) {
            return text.split(" ")
                    .map(item => item.length > 16 ? this.hyphenText(item) : item)
                    .join(" ");
        }

    },

}
</script>


<style scoped>
@media (min-width: 1024px) {
    .item {
        flex: 0 0 calc(25% - 8px);
    }
}

@media (min-width: 650px) {
    .item {
        flex: 0 0 calc((100% / 3) - 8px);
    }
}


@media (orientation: landscape) {
    .item {
        flex: 0 0 calc((100% / 3) - 8px);
    }
}

.section {
    margin-right: 14px;
}

.item {
    flex: 0 0 calc(50% - 8px);
    margin: 0 4px 8px;
    word-break: break-word;
}

.item.full {
    flex: 0 0 calc(100% - 8px) !important;
}

.item .child {
    width: 100%;
    height: 0;
    position: relative;
    padding-top: calc(178 / 167 * 100%);
}

.item.full .child {
    padding-top: calc(178 / 167 / 2 * 100%);
}

.item .child .image_position {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    transition: all 200ms;
    border-radius: 12px;
}

.item .child .image_root {
    background-size: 240px;
    background-color: #fff;
    background-position: center;
}

.item .child .image_root .image {
    border-radius: 12px;
    background-size: cover;
    width: 100%;
    height: 100%;
    background-position: center;
}

.item .child .image_root .image .link {
    width: 100%;
    height: 100%;
    display: block;
    padding: 12px;
}


.item .child .image_root .image .link .image_text {
    color: white;
    overflow: hidden;
    font-size: 20px;
    word-break: break-word;
    font-weight: normal;
}

.item .child .item-title {
    color: rgb(5, 0, 51);
    display: none;
}

.slide-banner.rounded .hooper-list {
    border-radius: 12px;
}

@media (max-width: 449px) {
    .item .child .image_root .image .link .image_text {
        font-size: 12px;
    }
}


/** special for hotel checkhoff **/
.item .child.with_border .image_root {
    border-radius: 15px;
    padding: 3px;
}

.item .child.chekhoff .image_root .image_text {
    font-family: Montserrat, sans-serif;
    font-size: 12px !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
}

.text-dark-blue {
    color: #061461;
}

.border-dark-blue {
    border: 1px solid #061461;
}

.image_root .temporary-unavailable {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    color: #fff;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.image_root .temporary-unavailable .temporary-unavailable_text {
    width: 100%;
    text-align: center;
    padding: 5px 5px;
}
@media screen and (min-width: 768px) {
    .horizontal >>> .v-hl-btn svg {
        color: black;
        border-radius: 10px;
        width: 40px;
        height: 40px;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.30) 100%);
        transition: background-color 1s ease-out;
    }

    .horizontal >>> .v-hl-btn svg:hover {
        background-color: rgba(255, 255, 255, 0.75);
    }
}
</style>